export default __webpack_public_path__ + "static/media/landing-mobile-06.b3bb2b50.png";